export default {
  "login": "themanmohan",
  "id": 65643224,
  "node_id": "MDQ6VXNlcjY1NjQzMjI0",
  "avatar_url": "https://avatars0.githubusercontent.com/u/65643224?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/themanmohan",
  "html_url": "https://github.com/themanmohan",
  "followers_url": "https://api.github.com/users/themanmohan/followers",
  "following_url": "https://api.github.com/users/themanmohan/following{/other_user}",
  "gists_url": "https://api.github.com/users/themanmohan/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/themanmohan/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/themanmohan/subscriptions",
  "organizations_url": "https://api.github.com/users/themanmohan/orgs",
  "repos_url": "https://api.github.com/users/themanmohan/repos",
  "events_url": "https://api.github.com/users/themanmohan/events{/privacy}",
  "received_events_url": "https://api.github.com/users/themanmohan/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Manmohan Kumar",
  "company": "Diomond.pvt",
  "blog": "www.hpboardguide.com",
  "location": "Baddi Himachal Pardesh India",
  "email": null,
  "hireable": null,
  "bio": "I am FullStack Developer",
  "twitter_username": "manmohankumar",
  "public_repos": 7,
  "public_gists": 0,
  "followers": 0,
  "following": 0,
  "created_at": "2020-05-20T04:43:25Z",
  "updated_at": "2020-08-29T08:12:03Z"
}
